import { LinkItem } from '@occc-app/design-system';
import { Cpg, ScanDataSftpCredentialStatus } from '@occc/graphql';

import { routeCreator } from '../../scan-data.router';

export const buildBreadcrumbLinks = (groupName: string): LinkItem[] => [
  { to: routeCreator.base(), label: 'Scan Data' },
  { key: 'Edit Submission Group', label: `Edit ${groupName || 'Submission Group'}` },
];

export const tobaccoCompanyOptions: { label: string; value: Cpg }[] = [
  { label: 'Altria', value: Cpg.Altria },
  { label: 'RJR', value: Cpg.Circana },
  { label: 'MSA', value: Cpg.Msa },
];

export const submissionTypeOptions: { label: string; value: ScanDataSftpCredentialStatus }[] = [
  { label: 'Production Submission', value: ScanDataSftpCredentialStatus.ProductionSubmission },
  { label: 'QA Submission', value: ScanDataSftpCredentialStatus.QaSubmission },
];
